<div class="app-shell">
  <div class="app-shell__route">
    <router-outlet *ngIf="!isServerAgencyRoute"></router-outlet>

    <app-update-popup></app-update-popup>

    <app-screen-recorder-indicator></app-screen-recorder-indicator>

    <!-- Hidden tour component - displayed via outlet in layout -->
    <ng-template #tourTemplate>
      <app-tour></app-tour>
    </ng-template>
  </div>

  <app-floating-thread-container class="app-shell__threads"></app-floating-thread-container>
</div>
